/**
 * <ReportTimeCard> — one timed measure of the session (molecule, L0.1).
 *
 * A card with its centered title, a glyph and the duration read from seconds — one of the three
 * legacy V1 blocks ("TEMPS CONNECTÉ.E AU LIVE" / "TEMPS D'EXPLICATION" / "TEMPS DE PRODUCTION
 * CHRONOMÉTRÉ", `LiveReportComponent:1153-1253`). The card is generic: the three titles and
 * glyphs are chosen by `<ReportSessionTimesCard>`. No hex.
 */
import React from "react"

import { Card } from "../Card"
import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Icon, type IconName } from "../../atoms/icons/Icon"
import { Text } from "../../atoms/typography/Text"
import { sessionDurationLabel } from "../../../ports/primary/ui/formatters/liveSessionReportFormatter"

export type ReportTimeCardProps = {
    /** Block title, uppercase in the legacy copy (kept verbatim by the caller). */
    title: string
    iconName: IconName
    /** Duration in seconds — the card formats it ("1 h 25 min 30 s"). */
    seconds: number
    testID?: string
}

export function ReportTimeCard(props: ReportTimeCardProps) {
    const { title, iconName, seconds, testID } = props

    return (
        <Card p="5" testID={testID}>
            <Stack gap="3" align="center">
                <Text size="text-xl" weight="bold" center>
                    {title}
                </Text>
                <Row gap="3" align="center">
                    <Icon name={iconName} size={32} color="primary" />
                    <Text size="text-3xl" weight="extrabold">
                        {sessionDurationLabel(seconds)}
                    </Text>
                </Row>
            </Stack>
        </Card>
    )
}
